<template>
  <aside class="ai-assistant">
    <div class="ai-assistant__header">
      <div>
        <span>Assistente biblico IA</span>
        <p>{{ chapterTitle || 'Pergunte sobre o estudo' }}</p>
      </div>
      <v-icon color="#8b6d32">mdi-sparkles</v-icon>
    </div>

    <v-textarea
      v-model="question"
      outlined
      hide-details
      no-resize
      rows="4"
      placeholder="Qual o contexto historico deste capitulo?"
      :disabled="loading || !sessionId"
      class="ai-assistant__field"
    ></v-textarea>

    <v-text-field
      v-model="verse"
      outlined
      dense
      hide-details
      type="number"
      min="1"
      label="Versiculo opcional"
      :disabled="loading || !sessionId"
      class="ai-assistant__field"
    ></v-text-field>

    <v-btn
      block
      color="#6f8063"
      dark
      depressed
      class="ai-assistant__button"
      :loading="loading"
      :disabled="!canAsk"
      @click="ask"
    >
      <v-icon left>mdi-send-outline</v-icon>
      Perguntar
    </v-btn>

    <v-alert v-if="error" dense text type="warning" class="ai-assistant__alert">
      {{ error }}
    </v-alert>

    <div v-if="answer" class="ai-assistant__answer">
      <p v-for="(paragraph, index) in formattedAnswer" :key="index">
        {{ paragraph }}
      </p>
    </div>
  </aside>
</template>

<script>
import bibleStudyService from '@/services/bibleStudyService';

export default {
  name: 'BibleAiAssistant',
  props: {
    sessionId: {
      type: [Number, String],
      default: null,
    },
    chapterTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      question: '',
      verse: '',
      answer: '',
      loading: false,
      error: '',
    };
  },
  computed: {
    canAsk() {
      return !!this.sessionId && this.question.trim().length > 0 && !this.loading;
    },
    formattedAnswer() {
      return String(this.answer || '')
        .split(/\n{2,}|\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);
    },
  },
  methods: {
    async ask() {
      if (!this.canAsk) return;

      this.loading = true;
      this.error = '';
      this.answer = '';

      try {
        const response = await bibleStudyService.perguntarIa({
          sessionId: this.sessionId,
          question: this.question.trim(),
          verse: this.verse,
        });

        this.answer = response?.answer || response?.resposta || response?.content || response?.message || String(response || '');
      } catch (error) {
        console.error('Erro ao perguntar para IA biblica:', error);
        this.error = 'Nao foi possivel consultar a IA agora.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.ai-assistant {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid rgba(159, 125, 60, 0.22);
  border-radius: 8px;
  background: linear-gradient(180deg, #fffdf8, #f5f7f4);
  box-shadow: 0 10px 28px rgba(71, 59, 42, 0.07);
}

.ai-assistant__header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.ai-assistant__header span {
  display: block;
  color: #433b32;
  font-size: 1rem;
  font-weight: 700;
}

.ai-assistant__header p {
  margin: 3px 0 0;
  color: #817769;
  font-size: 0.82rem;
}

.ai-assistant__field ::v-deep .v-input__slot {
  background: rgba(255, 255, 255, 0.72) !important;
  border-radius: 8px;
}

.ai-assistant__button {
  border-radius: 8px;
  letter-spacing: 0;
  text-transform: none;
}

.ai-assistant__alert {
  margin: 0;
}

.ai-assistant__answer {
  padding: 14px;
  border-radius: 8px;
  background: #fffaf1;
  border: 1px solid rgba(159, 125, 60, 0.16);
  color: #4d4439;
  font-size: 0.92rem;
  line-height: 1.65;
}

.ai-assistant__answer p {
  margin: 0 0 10px;
}

.ai-assistant__answer p:last-child {
  margin-bottom: 0;
}
</style>
